import "./App.css";
import { useEffect, useState } from "react";
import { authApi } from "./api";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import AdminDashboard from "./components/AdminDashboard";

function App() {
    const [authState, setAuthState] = useState("loading"); // loading | in | out
    const [user, setUser] = useState(null);

    const check = () => {
        authApi
            .me()
            .then((res) => {
                setUser(res.data.data);
                setAuthState("in");
            })
            .catch(() => setAuthState("out"));
    };
    useEffect(check, []);

    if (authState === "loading") {
        return (
            <div className="boot">
                <div className="boot__spinner" />
            </div>
        );
    }

    if (authState === "in") {
        const loggedOut = () => { setUser(null); setAuthState("out"); };
        if (user && user.role === "admin") {
            return <AdminDashboard user={user} onLoggedOut={loggedOut} />;
        }
        return <Dashboard user={user} onLoggedOut={loggedOut} />;
    }

    return <Login onLoggedIn={check} />;
}

export default App;
